exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@font-face{font-family:icomoon;src:url(" + require("../../fonts/icomoon.eot") + ");src:url(" + require("../../fonts/icomoon.eot") + ") format(\"embedded-opentype\"),url(" + require("../../fonts/icomoon.ttf") + ") format(\"truetype\"),url(" + require("../../fonts/icomoon.woff") + ") format(\"woff\"),url(" + require("../../fonts/icomoon.svg") + ") format(\"svg\");font-weight:400;font-style:normal}[class*=\" icon-\"],[class^=icon-]{font-family:icomoon!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.icon-left:before{content:\"\\E900\"}.icon-right:before{content:\"\\E901\"}.icon-down:before{content:\"\\E902\"}.icon-up:before{content:\"\\E903\"}.icon-icon-57-document-download:before{content:\"\\E904\"}.icon-profile:before{content:\"\\E923\"}.icon-table:before{content:\"\\EA71\"}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/css/components/icomoon.css
// module id = 785
// module chunks = 0